import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

export interface IAxiosErrorStore {
  error: {
    message: string;
    status: number;
  } | null;
  setError: (
    error: {
      message: string;
      status: number;
    } | null,
  ) => void;
}

export const useAxiosErrorStore = create<IAxiosErrorStore>()(
  subscribeWithSelector(
    devtools((set) => ({
      error: null,
      setError: (error) => {
        set({ error });
      },
    })),
  ),
);
